import Cookies from "js-cookie";
import {
  BACKEND_URL,
  getHeaders,
  getHeadersPhoto,
  handleResponse,
} from "./utils";
import { IClubCreate, IClubEdite } from "../types/club";

export async function getClubs(page: number = 1, limit: number = 10) {
  try {
    const response = await fetch(
      `${BACKEND_URL}/clubs?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: getHeaders(),
      },
    );

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get clubs:", error);
    throw error;
  }
}
export async function addClub(club: IClubCreate) {
  try {
    const response = await fetch(`${BACKEND_URL}/clubs`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(club),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error add clubs:", error);
    throw error;
  }
}
export async function editeClub(club: IClubEdite, id: number) {
  try {
    const response = await fetch(`${BACKEND_URL}/clubs/club/${id}`, {
      method: "PATCH",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(club),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error add clubs:", error);
    throw error;
  }
}

export async function deleteClubs(id: number) {
  try {
    const response = await fetch(`${BACKEND_URL}/clubs/${id}`, {
      method: "DELETE",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error delete clubs:", error);
    throw error;
  }
}

export async function getDeletedClubs() {
  try {
    const response = await fetch(`${BACKEND_URL}/clubs/deleted`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get clubs:", error);
    throw error;
  }
}
export async function getRestoreClubs(club: { clubId: number }) {
  try {
    const response = await fetch(`${BACKEND_URL}/clubs/restore`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(club),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get clubs:", error);
    throw error;
  }
}
